<template>
  <USelect
    v-model="view"
    :items="options"
    label-key="label"
    value-key="value"
  />
</template>

<script setup lang="ts">
import { useAuthStore } from '~/stores/useAuthStore'

const { t: $t } = useI18n()
const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()

const options = [
  { label: $t('datetime.labels.day'), value: '/schedule/day' },
  { label: $t('datetime.labels.week'), value: '/schedule/week' },
  { label: $t('datetime.labels.month'), value: '/schedule/month' },
  { label: $t('general.timetable'), value: '/schedule/timetable' },
  { label: $t('components.schedule.elements.viewControls.grid'), value: '/schedule/grid' },
]

const validViews = new Set(options.map(({ value }) => value))

function normalizeView(view: unknown): string {
  if (typeof view === 'string') {
    return view
  }

  if (view && typeof view === 'object') {
    const routeLike = view as { value?: unknown; path?: unknown }
    const raw = routeLike.value ?? routeLike.path
    if (typeof raw === 'string') {
      return raw
    }
  }

  return route.path
}

const view = computed({
  get() {
    return route.path
  },
  set(rawView: unknown) {
    const nextView = normalizeView(rawView)
    if (!validViews.has(nextView)) {
      return
    }

    authStore.setScheduleView({ view: nextView })

    if (nextView !== route.path) {
      router.push({
        path: nextView,
        query: route.query,
      })
    }
  },
})
</script>
